import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { AgencyHomeApiService } from '../agency-home-api.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AgencyHomeResolver implements Resolve<boolean> {

    constructor(private service: AgencyHomeApiService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.service.isReferralHistoryRecord();
    }

}
